
import React from 'react';

const DatosCabezaFamilia = ({ datos }) => {

  return (
    <div className="card">
        <div className="card-header">
            <h5 className="card-title m-0">Datos del Jefe de Hogar</h5>
        </div>
        <div className="card-body">
            <div className="row">
                <div className="col-md-12">
                    Nombre: <b>{datos.nombre}</b>
                </div>
            </div>
            <div className="row">
                <div className="col-md-4">
                    Identificacion: <b>{datos.cab_idcabezafamilia}</b>
                </div>
                {datos.cab_nodeclaracion && <div className="col-md-4">
                    Nro declaraci&oacute;n: <b>{datos.cab_nodeclaracion}</b>
                </div>}
            </div>
            <div className="row">
                <div className="col-md-4">
                    Direccion: <b>{datos.cab_direccion}</b>
                </div>
                <div className="col-md-3">
                    Telefonos: <b>{datos.telefono}</b> 
                </div>
                <div className="col-md-3">
                    Celular: <b>{datos.cab_celular}</b>
                </div>
            </div>
            <div className="row">
                <div className="col-md-4">
                    Correo Electronico: <b>{datos.cab_correoelectronico}</b>
                </div>
            </div>
        </div>
    </div>
  );
};

export default DatosCabezaFamilia;